import {
  ApiBlueprint,
  createApiFactory,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { configApiRef } from '@backstage/core-plugin-api';
import { scmAuthApiRef } from '@backstage/integration-react';
import {
  GithubPullRequestsClient,
  githubPullRequestsApiRef,
} from '@roadiehq/backstage-plugin-github-pull-requests';

const githubPRApi = ApiBlueprint.make({
  name: 'github-pull-requests',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: githubPullRequestsApiRef,
        deps: { configApi: configApiRef, scmAuthApi: scmAuthApiRef },
        factory: ({ configApi, scmAuthApi }) =>
          new GithubPullRequestsClient({ configApi, scmAuthApi }),
      }),
    ),
});

export const githubPRModule = createFrontendModule({
  pluginId: 'app',
  extensions: [githubPRApi],
});
